(function () {
  'use strict';

  /**
   * iOS Safari 判定（Chrome iOS / Firefox iOS は除外）
   */
  function isIOSSafari() {
    var ua = window.navigator.userAgent || '';
    var isIOS = /iP(ad|hone|od)/.test(ua);
    var isWebKit = /WebKit/.test(ua);
    var isNotCriOS = !/CriOS/.test(ua); // Chrome iOS
    var isNotFxiOS = !/FxiOS/.test(ua); // Firefox iOS
    return isIOS && isWebKit && isNotCriOS && isNotFxiOS;
  }

  function applyIOSSafariClass() {
    try {
      if (isIOSSafari()) {
        document.documentElement.classList.add('is-ios-safari');
      } else {
        document.documentElement.classList.remove('is-ios-safari');
      }
    } catch (e) {
      // 何もしない
    }
  }

  // 初回（できるだけ早く）
  applyIOSSafariClass();

  // ブラウザバック/フォワード（BFCache復帰）でも必ず実行
  window.addEventListener('pageshow', function () {
    applyIOSSafariClass();
  });

  window.addEventListener('load', function () {
    var mainAtcBtn = document.querySelector('.product-form__submit');
    var footerAtcBtn = document.querySelector('.js-footer-atc-button');
    var container = document.querySelector('.floating-atc');

    if (mainAtcBtn && footerAtcBtn && container) {
      var updateFooterButton = function () {
        // 無効化状態の同期
        footerAtcBtn.disabled = mainAtcBtn.disabled;

        // 常にメインボタンのテキストを反映
        var textSpan = footerAtcBtn.querySelector('span');
        if (textSpan) {
          textSpan.innerText = (mainAtcBtn.innerText || '').trim();
        }
      };

      var observer = new MutationObserver(updateFooterButton);
      observer.observe(mainAtcBtn, { attributes: true, childList: true, subtree: true });

      // 初回の状態同期
      updateFooterButton();
    }
  });
})();